import { render } from "./FileUploader.vue?vue&type=template&id=54a79c50&scoped=true"
import script from "./FileUploader.vue?vue&type=script&lang=js"
export * from "./FileUploader.vue?vue&type=script&lang=js"

import "./FileUploader.vue?vue&type=style&index=0&id=54a79c50&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.2.47_vue@3.2.47_webpack@5.90.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54a79c50"]])

export default __exports__